import { createContext } from "react";

export type CurrentUser = {
  username: string;
  role: string;
  logout?: () => Promise<void>;
};

export const CurrentUserContext = createContext<CurrentUser | null>(null);
